<template>
  <div class="btn-group text-gray-700" :class="[stateSwith == true ? 'btn-group--on' : 'btn-group--off']" role="group" aria-label="First group">
    <CButton type="button" @click="toggleSwicthe(true)" class="btn__on text-uppercase">{{ $t(`general.components.switch.on`) }}</CButton>
    <CButton type="button" @click="toggleSwicthe(false)" class="btn__off text-uppercase">{{ $t(`general.components.switch.off`) }}</CButton>
  </div>
</template>

<script>
export default {
  name: 'ToogleSwitch',
  props: {
    stateSwith: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    toggleSwicthe(status) {
      this.$emit('toggle-switch', status)
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-group {
  background-color: var(--gray-200);
  border: 1px solid var(--gray-200);

  .btn {
    color: var(--gray-600);
    border: none;
    border-radius: 0;
    padding: 0.5rem;
    min-width: 45px;
    font-weight: normal;

    &:before {
      box-shadow: none !important;
    }

    &__on:hover {
      color: var(--primary);
    }
    &__off:hover {
      color: var(--primary);
    }
  }

  &--on {
    .btn.btn__on {
      color: white;
      background: var(--primary);

      &:hover {
        background: var(--primary);
      }
    }
  }

  &--off {
    .btn__off {
      color: var(--white);
      background: var(--primary);

      &:hover {
        color: var(--white);
        background: var(--primary);
      }
    }
  }
}
</style>
